import { truncateName, truncateCombinedNames } from '../../lib/text'

interface ProductNameProps {
  name: string
  url: string
  /** Secondary product name (h2_product_name attribute) */
  h2ProductName?: string | null
}

const NAME_TEXT_CLASSES = 'react-css leading-[14px] md:leading-[16px] xl:leading-5 text-center text-xs md:text-sm xl:text-base font-normal font-main-font text-text-color h-[42px] md:h-[50px] xl:h-[65px] overflow-hidden'

/**
 * ProductName - Centered product name with optional h2 secondary name
 *
 * Matches CardItem.tsx: centered text, combined name truncation (75 chars).
 * Primary name truncated at 70 chars, then combined with h2 name.
 */
export function ProductName({ name, url, h2ProductName }: ProductNameProps) {
  const cutName = truncateName(name)
  const [adjustedName, adjustedH2Name] = truncateCombinedNames(cutName, h2ProductName)

  return (
    <a
      href={url}
      title={name}
      className="h-[44px] md:h-[52px] xl:h-[65px] text-black hover:no-underline active:text-black overflow-hidden"
    >
      <p className={NAME_TEXT_CLASSES}>
        {adjustedName}
        {adjustedH2Name && (
          <span className={NAME_TEXT_CLASSES}>
            {adjustedH2Name}
          </span>
        )}
      </p>
    </a>
  )
}
